import React, { useMemo } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Brushaway } from '@ui/molecules/Brushaway';
import EmbeddedDeficiencyDetail from '../../DeficiencyShow/EmbeddedDeficiencyDetail';
function EmbeddedDeficiencyDetailBrushaway({ isOpen = false, deficiencyId = null, onClose, deficiencyStatuses = [], tags = [] }) {
    const queryClient = useMemo(() => new QueryClient(), []);
    return (React.createElement(Brushaway, { controlledOpen: isOpen, onClose: onClose, minWidth: 680 },
        React.createElement(QueryClientProvider, { client: queryClient }, deficiencyId && (React.createElement(EmbeddedDeficiencyDetail, { deficiencyId: deficiencyId, onClose: onClose, deficiencyStatuses: deficiencyStatuses, tags: tags })))));
}
export default EmbeddedDeficiencyDetailBrushaway;
